<template>
  <div class="time-date-display d-flex flex-column align-items-center mb-3">
    <div class="time-display d-flex align-items-center justify-content-center mb-2">
      <i class="fas fa-clock mr-2" />
      <span class="current-time">{{ currentTime }}</span>
    </div>
    <div class="date-display d-flex align-items-center justify-content-center">
      <i class="fas fa-calendar-alt mr-2" />
      <span class="current-date">{{ currentDate }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimeDisplay',
  data() {
    return {
      currentTime: this.getFormattedTime(),
      currentDate: this.getFormattedDate(),
      timeInterval: null,
    }
  },
  mounted() {
    this.timeInterval = setInterval(this.updateTimeAndDate, 1000)
  },
  beforeDestroy() {
    if (this.timeInterval) {
      clearInterval(this.timeInterval)
    }
  },
  methods: {
    getFormattedTime() {
      return moment().format('HH:mm:ss')
    },
    getFormattedDate() {
      return moment().format('DD/MM/YYYY')
    },
    updateTimeAndDate() {
      this.currentTime = this.getFormattedTime()
      this.currentDate = this.getFormattedDate()
    },
  },
}
</script>

<style scoped>
.time-date-display {
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
}

.time-display,
.date-display {
  font-size: 2.5rem;
  font-weight: bold;
  width: 100%;
  justify-content: center;
}

.time-display i,
.date-display i {
  font-size: 2.5rem;
  color: #007bff;
}

.current-time,
.current-date {
  margin-left: 10px;
  font-size: 64px;
  text-align: center;
  word-break: break-word;
}

@media (max-width: 576px) {
  .current-time,
  .current-date {
    margin-left: 5px;
    font-size: 32px !important;
    word-break: break-word;
  }

  .time-display i,
  .date-display i {
    font-size: 1.5rem !important;
  }
}
</style>
